import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import tableComponent from '@/components/TableComponent/index';
import defaultTable from "./components/defaultTable";
import redirectTable from "./components/redirectTable";
import { cloneDeep, isEqual } from 'lodash';
export default {
  props: ["deviceDid", "deviceSn"],
  components: {
    tableComponent: tableComponent,
    defaultTable: defaultTable,
    redirectTable: redirectTable
  },
  data: function data() {
    return _defineProperty({
      checked: true,
      //控制dom更新的生命周期操作
      UpData: true,
      IpList: [],
      updateData: [],
      deleteOptions: [],
      // 网络接口基本信息
      networkInfo: {},
      firewallData: {
        default: [],
        redirect: []
      },
      loading: false,
      redirectLength: 0,
      copyData: {
        default: [],
        redirect: []
      }
    }, "loading", false);
  },
  mounted: function mounted() {
    var _this = this;

    //获取下拉ip列表
    listConfig(this.deviceSn, this.deviceDid, [{
      section: 'arp',
      config: 'arp'
    }]).then(function (res) {
      _this.IpList = res.data.data.mess[0].s_objects.map(function (val) {
        return {
          value: val.ipaddr,
          label: "".concat(val.ipaddr, " (").concat(val.macaddr, ")")
        };
      });

      _this.IpList.push({
        value: '自定义',
        label: _this.$t('lang.ConfigSetting.custom')
      });

      _this.IpList.push({
        value: '',
        label: _this.$t('lang.firewall.all')
      });
    });
    this.getConfig(); // this.fetchNetworkInfo()
  },
  methods: {
    // 获取防火墙数据
    getConfig: function getConfig() {
      var _this2 = this;

      this.firewallData = {
        default: [],
        redirect: []
      };
      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "defaults",
        config: "firewall",
        options: [{
          option: "syn_flood"
        }, {
          option: "drop_invalid"
        }, {
          option: "input"
        }, {
          option: "output"
        }, {
          option: "forward"
        }, {
          option: ""
        }]
      }, {
        section: "redirect",
        config: "firewall",
        options: [{
          option: "enabled"
        }, {
          option: "target"
        }, {
          option: "src"
        }, {
          option: "src_ip"
        }, {
          option: "dest"
        }, {
          option: "proto"
        }, {
          option: "src_dip"
        }, {
          option: "name"
        }, {
          option: "dest_ip"
        }, {
          option: "extra"
        }]
      }]).then(function (res) {
        res.data.data.mess.forEach(function (item, index) {
          if (item.section === 'redirect') {
            _this2.redirectLength = item.s_objects.length;
            item.s_objects.forEach(function (ele, index) {
              var eleObj = ele;

              _this2.$set(eleObj, 'index', index);

              if (ele.options.target == 'SNAT') {
                eleObj.options.enabled = eleObj.options.enabled == '0' ? false : true;

                _this2.firewallData.redirect.push(eleObj);
              }
            });
          } else if (item.section === 'defaults') {
            item.s_objects.forEach(function (ele, index) {
              var eleObj = ele;

              _this2.$set(eleObj, 'index', index);

              eleObj.options.drop_invalid = eleObj.options.drop_invalid == '1' ? true : false;
              eleObj.options.syn_flood = eleObj.options.syn_flood == '1' ? true : false;

              _this2.firewallData.default.push(eleObj);
            });
          }
        });
        _this2.copyData = cloneDeep(_this2.firewallData);
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message({
          message: _this2.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    // 更新数据
    updateFirewall: function updateFirewall() {
      this.getConfig();
    },
    // 更新并应用
    updateRedirect: function updateRedirect() {
      var _this3 = this;

      if (!isEqual(this.copyData, this.firewallData)) {
        var data = [];
        this.firewallData.default.forEach(function (item, index) {
          var action = 0;
          var options = cloneDeep(item.options);
          options.drop_invalid = options.drop_invalid ? "1" : "";
          options.syn_flood = options.syn_flood ? "1" : "";

          if (item.action == undefined) {
            action = 0;
          } else {
            action = item.action;
          }

          data.push({
            server: "firewall",
            config: 'firewall',
            section: 'defaults',
            action: action,
            options: options,
            index: [item.index]
          });
        });
        this.firewallData.redirect.forEach(function (item, index) {
          var action = 0;
          var options = cloneDeep(item.options);
          options.enabled = options.enabled == false ? "0" : "";

          if (item.action == undefined) {
            action = 0;
          } else {
            action = item.action;
          }

          data.push({
            server: "firewall",
            config: 'firewall',
            section: 'redirect',
            action: action,
            options: options,
            index: [item.index]
          });
        });
        this.deleteOptions.forEach(function (item, index) {
          var options = cloneDeep(item.options);

          if (options.enabled) {
            options.enabled = '1';
          } else {
            options.enabled = '0';
          }

          data.push({
            section: "redirect",
            config: "firewall",
            action: item.action,
            index: [item.index],
            server: "firewall",
            options: options
          });
        });
        updateConfig(this.deviceSn, this.deviceDid, data).then(function (res) {
          if (res.data.data.mess === 0) {
            _this3.$message({
              showClose: true,
              message: _this3.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });

            _this3.deleteOptions = [];

            _this3.getConfig();
          } else {
            _this3.$message({
              showClose: true,
              message: _this3.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });

            _this3.getConfig();

            return;
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return;
      }
    }
  }
};